export const colors = {
  BLUE: "blue",
  YELLOW: "yellow",
  GREEN: "green",
  RED: "red",
  ORANGE: "orange",
  PURPLE: "purple",
};



// WEBPACK FOOTER //
// ./src/enums.js